import { render } from "./_form-iban.vue?vue&type=template&id=ce71bd0a"
import script from "./_form-iban.vue?vue&type=script&lang=js"
export * from "./_form-iban.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__